

import {
  type DraggableEvent,
  type UseDraggableReturn,
  VueDraggable
} from 'vue-draggable-plus'

import { toRaw } from 'vue';

export default {
  name: "rotas-table",
  components: {
    VueDraggable
  },
    props: {
      rotas: {
        type: Array,
        default: () => {
          [];
        },
      },
      motoristas: {
        type: Array,
        default: () => {
          [];
        },
      },
      veiculos: {
        type: Array,
        default: () => {
          [];
        },
      },
      map: {
        type: Object,
        default: () => {
          return {}; // Retorna um objeto vazio como valor padrão
        },
      },
      alocarMotorista: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      alocarVeiculo: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      toggleRoute: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      toggleUnicRoute: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },

      reOrdenar: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      salvarRotas: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      removerRota: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      
      
    },
    data() {
      return {
        por_pagina : false,
        isLast: false,
        showConfirmModal:false
      }
    },
    setup(props:any) {
      // Acessando as props diretamente sem usar `this`
      const setCenter = (rota: any) => {
        if (rota.Operacao && rota.Operacao.latitude && rota.Operacao.longitude) {
          const newLocation = {
            lat: parseFloat(rota.Operacao.latitude),
            lng: parseFloat(rota.Operacao.longitude),
          };

          if (props.map && typeof props.map.setCenter === 'function') {
            props.map.setCenter(newLocation); // Define o novo cen tro do mapa
          } else {
            console.error("Mapa inválido ou setCenter não é uma função");
          }


          props.toggleRoute(rota);
          
        } else {
          console.error("Coordenadas inválidas ou não fornecidas");
        }
      };

      const setCenterItem = (pedido: any) => {
        if (pedido.latitude && pedido.longitude) {
          const newLocation = {
            lat: parseFloat(pedido.latitude),
            lng: parseFloat(pedido.longitude),
          };

          if (props.map && typeof props.map.setCenter === 'function') {
            props.map.setCenter(newLocation); // Define o novo cen tro do mapa
          } else {
            console.error("Mapa inválido ou setCenter não é uma função");
          }
        } else {
          console.error("Coordenadas inválidas ou não fornecidas");
        }
      };





      const alocarMotorista = (veiculo: any, rota_id: any, operador: any, rota: any) => {
        
        props.alocarMotorista(veiculo, rota_id, operador);

        rota.operador= { nome_completo : "", is_update : true }
        rota.editingOperador = false;

      }


      const alocarVeiculo = (veiculo: any, rota_id: any, operador: any, rota: any) => {
        
        props.alocarVeiculo(veiculo, rota_id, operador);

        rota.operador= { nome_completo : "", is_update : true }
        rota.editingVeiculo = false;

      }

      const onStart = (e: DraggableEvent) => {
        console.log('start', e.data.id_pedido)
      }


      const onEnd = (e: DraggableEvent, rotaId:any) => {
        console.log('onEnd', e)
        console.log('onEnd', rotaId)

        let pedido = { id_rota:rotaId, id_pedido : e.data.id_pedido, ordem: (e.newIndex || 1 ) }
        
        console.log(pedido)
        props.reOrdenar(pedido);
        
      }

      const onUpdate = () => {
        console.log('update')
      }


      const toggleRoute = (rota: any) => {
        
        props.toggleRoute(rota);

      }

      const toggleUnicRoute = (rota: any) => {
        
        props.toggleUnicRoute(rota);

      }

      const salvarRota = (rota: any) => {
        

        props.salvarRotas(rota);

      }

      const removerRota = (rota: any) => {
        

        props.removerRota(rota);

      }

      const getClassByStatus = (status: Number) => {
          if (status === 0) return 'pedido-item-step-status-desativado'; // Pedido desativado
          if (status === 1) return 'pedido-item-step-status-ativo';     // Pedido ativo
          if (status === 2) return 'pedido-item-step-status-concluido'; // Pedido concluído
          if (status === 5) return 'pedido-item-step-status-aguardando'; // Pedido concluído
          return '';
      }

      // Retorna os métodos ou variáveis que você quer expor
      return {

        setCenter,
        setCenterItem,
        alocarMotorista,
        alocarVeiculo,
        toggleRoute,
        toggleUnicRoute,
        onStart,
        onEnd,
        onUpdate,
        salvarRota,
        getClassByStatus,
        removerRota
        
      };
    }
};
